import { fetch } from "src/services/apollo-fetch";
import { Mutation } from "../_api";

export default {
    async addPreOrderUnit(context, data) {
        const response = await fetch.mutate(
            {
                mutation: Mutation.addPreOrderUnit,
                variables: { input: data },
            },
            { message: "Unit added" },
        );
        return response.data.addPreOrderUnit.unitId;
    },
};
